export const blockIconsCommonactionsEventNew = (
	<span className='material-symbols-outlined'>event</span>
);
